// UIContext.js
import React, { createContext, useContext, useState } from "react";

const UIContext = createContext();

export const UIContextProvider = ({ children }) => {
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [toastCenterTop, setToastCenterTop] = useState({
    visible: false,
    message: "",
    duration: 3000,
    color: null,
  });
  const [toastCenterBottom, setToastCenterBottom] = useState({
    visible: false,
    message: "",
    duration: 3000,
    color: null,
  });

  const [alertModalState, setAlertModalState] = useState({
    visible: false,
    message: "",
  });

  const [toastPromptModalState, setToastPromptModalState] = useState({
    visible: false,
    message: "",
    onConfirm: null,
    onCancel: null,
  });

  const [toastConfirmModalState, setToastConfirmModalState] = useState({
    visible: false,
    message: "",
    onConfirm: null,
    onCancel: null,
  });

  const handleToastPromptModal = (message, onConfirm, onCancel) => {
    setToastPromptModalState({
      visible: true,
      message,
      onConfirm,
      onCancel,
    });
  };

  // 토스트 메시지를 표시하거나 숨기는 함수
  const handleToastCenterTop = (message, duration = 3000, color = null) => {
    setToastCenterTop({ visible: !!message, message, duration, color });
    if (message) {
      setTimeout(() => {
        setToastCenterTop({
          visible: false,
          message: "",
          duration: 3000,
          color: null,
        });
      }, duration);
    }
  };

  const handleToastCenterBottom = (message, duration = 3000, color = null) => {
    setToastCenterBottom({ visible: !!message, message, duration, color });
    if (message) {
      setTimeout(() => {
        setToastCenterBottom({
          visible: false,
          message: "",
          duration: 3000,
          color: null,
        });
      }, duration);
    }
  };

  return (
    <UIContext.Provider
      value={{
        isLoadingModal,
        setIsLoadingModal,
        toastCenterTop,
        handleToastCenterTop,
        alertModalState,
        setAlertModalState,
        toastCenterBottom,
        handleToastCenterBottom,
        toastPromptModalState,
        setToastPromptModalState,
        handleToastPromptModal,
        toastConfirmModalState,
        setToastConfirmModalState,
      }}
    >
      {children}
    </UIContext.Provider>
  );
};

export const useUIContext = () => useContext(UIContext);
